import { SET_FILTERS_PRODUCTS,SET_FILTERS_PRODUCTS_LOADER } from './types';

export const saveFiltersProductsAction = filtersProducts => {
  return { type: SET_FILTERS_PRODUCTS, payload: filtersProducts };
};
export const saveFiltersIsLoadingAction = isLoading => ({ type: SET_FILTERS_PRODUCTS_LOADER, payload: isLoading });
